import { Formik, Form, ErrorMessage } from 'formik';
import { useState } from 'react';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { RadioButton } from 'primereact/radiobutton';
import { Title } from 'components/Title';
import useApi from 'hooks/useApi';
import useApp from 'hooks/useApp';
import useUtils from 'hooks/useUtils';

import useAddPage from 'hooks/useAddPage';
import DepositCalculator from "../../services/DepositCalculator";
const DepositesAddPage = (props) => {
		const app = useApp();
	const api = useApi();
	const utils = useUtils();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		policyno: yup.string().required().label($t('policyno')),
		groupid: yup.string().nullable().label($t('groupid')),
		memberid: yup.string().required().label($t('memberid')),
		policydate: yup.string().required().label($t('policydate')),
		productid: yup.string().required().label($t('productid')),
		deposite_type: yup.string().nullable().label($t('depositeType')),
		frequency: yup.string().required().label($t('frequency')),
		term_period: yup.number().nullable().label($t('termPeriod')),
		interest: yup.number().required().label($t('interest')),
		amort_type: yup.string().required().label($t('amortType')),
		compounding: yup.string().nullable().label($t('compounding')),
		units: yup.string().nullable().label($t('units')),
		amount: yup.string().required().label($t('amount')),
		maturitydate: yup.string().required().label($t('maturityDate')),
		maturityamount: yup.string().required().label($t('maturityAmount')),
		deduct_from_savings: yup.string().nullable().label($t('deductFromSavings')),
		branchcode: yup.string().nullable().label($t('branchcode')),
		empcode: yup.string().required().label($t('empcode')),
		term: yup.string().nullable().label($t('term'))
	});
	
	//form default values
	const formDefaultValues = {
		policyno: utils.randomNum(6), 
		groupid: '', 
		memberid: '', 
		policydate: new Date(), 
		productid: '', 
		deposite_type: '', 
		frequency: '', 
		term_period: '', 
		interest: '', 
		amort_type: '', 
		compounding: '', 
		units: '', 
		amount: '', 
		maturitydate: new Date(), 
		maturityamount: '', 
		deduct_from_savings: '', 
		branchcode: '', 
		empcode: '', 
		term: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/deposites`);
		}
	}
	
	//auto fill other inputs on memberid change
	async function memberidAutoFill(e, formik, index) {
		formik.handleChange(e);
		const val = e.target.value;
		const resp = await api.get(`components_data/deposites_memberid_autofill?value=${val}`);
		const data = resp.data[0];
		if(data){
formik.setFieldValue('branchcode', data.branchcode);
		}
	};
	
	//auto fill other inputs on productid change
	async function productidAutoFill(e, formik, index) {
		formik.handleChange(e);
		const val = e.target.value;
		const resp = await api.get(`components_data/deposites_productid_autofill?value=${val}`);
		const data = resp.data[0];
		if(data){
formik.setFieldValue('deposite_type', data.deposit_type);
formik.setFieldValue('frequency', data.frequency);
formik.setFieldValue('term_period', data.term_period);
formik.setFieldValue('interest', data.interestrate);
formik.setFieldValue('amort_type', data.amort_type);
formik.setFieldValue('compounding', data.compounding);
		}
	};
	
	//auto fill other inputs on units change
	async function unitsAutoFill(e, formik, index) {
		formik.handleChange(e);
    // Get the new value directly from the event
    const newUnits = parseFloat(e.target.value) || 0;
    // Update the formik value
    formik.setFieldValue('units', newUnits);
    // Calculate amount with the new units value
    setTimeout(() => {
        const termPeriod = parseFloat(formik.values.term_period) || 0;
        const frequency = formik.values.frequency || 'Monthly';
        // Calculate total periods based on frequency
        let periods = 0;
        switch(frequency) {
            case 'Monthly':
                periods = termPeriod;
                break;
            case 'Quarterly':
                periods = termPeriod;
                break;
            case 'Half-Yearly':
                periods = termPeriod;
                break;
            case 'Yearly':
                periods = termPeriod;
                break;
                 case 'Daily':
                periods = termPeriod;
                break;
                 case 'Weekly':
                periods = termPeriod;
                break;
                 case 'BiWeekly':
                periods = termPeriod;
                break;
            default:
                periods = termPeriod;
        }
        const totalAmount =  newUnits * periods;
        // Set amount field
        formik.setFieldValue('amount', Math.round(totalAmount * 100) / 100);
         // Pass the newUnits value to calculateDeposit
        calculateDeposit(formik, newUnits);
    }, 100);
	};
const [product, setProduct] = useState({});
const [result, setResult] = useState({});
// Helper function to get term type from frequency
const getTermTypeFromFrequency = (frequency) => {
    const mapping = {
        'Daily': 'Day',
        'Weekly': 'Week',
        'BiWeekly': 'Week',
        'Monthly': 'Month',
        'Quarterly': 'Month',
        'Half-Yearly': 'Month',
        'Yearly': 'Year'
    };
    return mapping[frequency] || 'Month';
};
const calculateDeposit = (formik, overrideUnits = null) => {
    const frequency = formik.values.frequency || 'Monthly';
    const termPeriod = parseFloat(formik.values.term_period) || 0;
    const depositType = formik.values.deposittype || 'RD';
    // For RD/DDS: termType should be derived from frequency
    let termType;
    if (depositType === 'RD' || depositType === 'DDS') {
        termType = getTermTypeFromFrequency(frequency);
        } else {
        // For FD/MIS: use actual term type
        termType = formik.values.term_type || 'Month';
    }
        // Use overrideUnits if provided, otherwise use formik values
    const unitsToUse = overrideUnits !== null ? overrideUnits : parseFloat(formik.values.units) || 0;
   const productData = {
        depositType: depositType,
        frequency: frequency,
        installmentAmount: unitsToUse,
        term: termPeriod,
        termType: termType,
        interestRate: parseFloat(formik.values.interest) || 0,
        interestType: formik.values.amort_type || 'Compound',
        compounding: formik.values.compounding || 'Monthly'
    };
    console.log('Product Data being sent:', productData);
    setProduct(productData);
    if (productData.depositType && productData.interestRate > 0 && productData.term > 0 && productData.installmentAmount > 0) {
        try {
            const startDate = formik.values.policydate ? new Date(formik.values.policydate) : new Date();
            const calcResult = DepositCalculator.calculate(
            productData,
            startDate
            );
            console.log('Calculation Result:', calcResult);
            setResult(calcResult);
            if (calcResult) {
                // Set maturity amount
                if (calcResult.maturityAmount !== undefined && calcResult.maturityAmount !== null) {
                    formik.setFieldValue('maturityamount', Math.round(calcResult.maturityAmount * 100) / 100);
                }
                // Set maturity date
                if (calcResult.maturityDate) {
                    // Format the date properly
                    const maturityDate = new Date(calcResult.maturityDate);
                    formik.setFieldValue('maturitydate', maturityDate);
                }
                // Set interest
                if (calcResult.interest !== undefined) {
                    formik.setFieldValue('interest_earned', Math.round(calcResult.interest * 100) / 100);
                }
                // Set principal
                if (calcResult.principal !== undefined) {
                    formik.setFieldValue('principal', Math.round(calcResult.principal * 100) / 100);
                }
            }
            } catch (error) {
            console.error('Calculation error:', error);
        }
        } else {
        console.log('Missing required fields for calculation:', {
            depositType: productData.depositType,
            interestRate: productData.interestRate,
            term: productData.term,
            installmentAmount: productData.installmentAmount
        });
    }
};
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="DepositesAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewDeposite')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container-fluid">
            <div className="grid ">
                <div className="col comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-4 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('policyno')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="policyno"  onChange={formik.handleChange}  value={formik.values.policyno}   label={$t('policyno')} type="text" placeholder={$t('enterPolicyno')}     disabled   className={inputClassName(formik?.errors?.policyno)} />
                                                <ErrorMessage name="policyno" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-4 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('groupid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/groupid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="groupid"     optionLabel="label" optionValue="value" value={formik.values.groupid} onChange={formik.handleChange} options={response} label={$t('groupid')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.groupid)}   />
                                                    <ErrorMessage name="groupid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-4 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('memberid')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource onLoad={(res) => formik.setFieldValue('memberid', '')} loadOnMount={false} apiPath={`components_data/memberid_option_list?lookup_groupid=${formik.values.groupid}`}  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="memberid"     optionLabel="label" optionValue="value" value={formik.values.memberid} onChange={(e)=>memberidAutoFill(e, formik)} options={response} label={$t('memberid')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.memberid)}   />
                                                    <ErrorMessage name="memberid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-4 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('policydate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="policydate" showButtonBar className={inputClassName(formik?.errors?.policydate)} dateFormat="yy-mm-dd" value={formik.values.policydate} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="policydate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-4 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('productid')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/productid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="productid"     optionLabel="label" optionValue="value" value={formik.values.productid} onChange={(e)=>productidAutoFill(e, formik)} options={response} label={$t('productid')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.productid)}   />
                                                    <ErrorMessage name="productid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-4 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('depositeType')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="deposite_type"  onChange={formik.handleChange}  value={formik.values.deposite_type}   label={$t('depositeType')} type="text" placeholder={$t('enterDepositeType')}     disabled   className={inputClassName(formik?.errors?.deposite_type)} />
                                                <datalist id="deposite_type_list">
                                                { app.menus.depositeType.map((option, index)=> <option key={index} value={option.value}>{option.label}</option>)}
                                                </datalist>
                                                <ErrorMessage name="deposite_type" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-4 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('frequency')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="frequency"  onChange={formik.handleChange}  value={formik.values.frequency}   label={$t('frequency')} type="text" placeholder={$t('enterFrequency')}     disabled   className={inputClassName(formik?.errors?.frequency)} />
                                                <ErrorMessage name="frequency" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-4 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('termPeriod')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="term_period"  onChange={formik.handleChange}  value={formik.values.term_period}   label={$t('termPeriod')} type="number" placeholder={$t('enterTermPeriod')}  min={0}  step="any" disabled   className={inputClassName(formik?.errors?.term_period)} />
                                                <ErrorMessage name="term_period" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-4 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('interest')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="interest"  onChange={formik.handleChange}  value={formik.values.interest}   label={$t('interest')} type="number" placeholder={$t('enterInterest')}  min={0}  step={0.1} disabled   className={inputClassName(formik?.errors?.interest)} />
                                                <ErrorMessage name="interest" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-4 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('amortType')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="amort_type"  onChange={formik.handleChange}  value={formik.values.amort_type}   label={$t('amortType')} type="text" placeholder={$t('enterAmortType')}     disabled   className={inputClassName(formik?.errors?.amort_type)} />
                                                <ErrorMessage name="amort_type" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-4 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('compounding')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="compounding"  onChange={formik.handleChange}  value={formik.values.compounding}   label={$t('compounding')} type="text" placeholder={$t('enterCompounding')}     disabled   className={inputClassName(formik?.errors?.compounding)} />
                                                <ErrorMessage name="compounding" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-4 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('units')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="units"  onChange={(e)=>unitsAutoFill(e, formik)}  value={formik.values.units}   label={$t('units')} type="text" placeholder={$t('enterUnits')}        className={inputClassName(formik?.errors?.units)} />
                                                <ErrorMessage name="units" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-4 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('amount')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="amount"  onChange={formik.handleChange}  value={formik.values.amount}   label={$t('amount')} type="text" placeholder={$t('enterAmount')}        className={inputClassName(formik?.errors?.amount)} />
                                                <ErrorMessage name="amount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-4 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('maturityDate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="maturitydate" value={formik.values.maturitydate} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.maturitydate)}     disabled   />
                                                <ErrorMessage name="maturitydate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-4 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('maturityAmount')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="maturityamount"  onChange={formik.handleChange}  value={formik.values.maturityamount}   label={$t('maturityAmount')} type="text" placeholder={$t('enterMaturityAmount')}     disabled   className={inputClassName(formik?.errors?.maturityamount)} />
                                                <ErrorMessage name="maturityamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-4 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('deductFromSavings')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                {
                                                app.menus.deductFromSavings.map((option) => {
                                                return (
                                                <div key={option.value} className="field-radiobutton">
                                                    <RadioButton inputId={option.value} name="deduct_from_savings" value={option.value} onChange={formik.handleChange}  checked={formik.values.deduct_from_savings === option.value} className={inputClassName(formik?.errors?.deduct_from_savings, '')} />
                                                    <label htmlFor={option.value}>{option.label}</label>
                                                </div>
                                                )
                                                })
                                                }
                                                <ErrorMessage name="deduct_from_savings" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-4 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('branchcode')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/branchcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="branchcode"     optionLabel="label" optionValue="value" value={formik.values.branchcode} onChange={formik.handleChange} options={response} label={$t('branchcode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.branchcode)}   />
                                                    <ErrorMessage name="branchcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-4 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('empcode')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/empcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="empcode"     optionLabel="label" optionValue="value" value={formik.values.empcode} onChange={formik.handleChange} options={response} label={$t('empcode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.empcode)}   />
                                                    <ErrorMessage name="empcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-4 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('term')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="term"  onChange={formik.handleChange}  value={formik.values.term}   label={$t('term')} type="text" placeholder={$t('enterTerm')}        className={inputClassName(formik?.errors?.term)} />
                                                <ErrorMessage name="term" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
DepositesAddPage.defaultProps = {
	primaryKey: 'policyno',
	pageName: 'deposites',
	apiPath: 'deposites/add',
	routeName: 'depositesadd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default DepositesAddPage;
